export default __webpack_public_path__ + "static/media/Sneaker.902b2f0c.png";